
import React from 'react';
import { Button } from "@/components/ui/button";
import { Clock, Edit } from "lucide-react";

interface NoScheduleStateProps {
  onEditClick: () => void;
}

const NoScheduleState: React.FC<NoScheduleStateProps> = ({ onEditClick }) => {
  return (
    <div className="text-center py-8 text-muted-foreground">
      <Clock className="h-12 w-12 mx-auto mb-4 opacity-50" />
      <p className="mb-2">Nenhum horário configurado para esta data</p>
      <Button onClick={onEditClick} className="mt-4">
        <Edit className="h-4 w-4 mr-2" />
        Configurar Horários
      </Button>
    </div>
  );
};

export default NoScheduleState;
